export enum FinancialsDataMode {
  ByMonth = 1,
  ByMilestone = 2,
}

export enum FinancialsType {
  DevCost = 1,
  DevHeadcount = 2,
}
